import { useMemo, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import InputSearchSuffixIcon from 'components/InputSearchSuffixIcon';
import shopSelectors from 'services/shop/selectors';
import { IStaffAvailableItem } from 'services/shop/types/staff';
import styled from 'styled-components';
import userSelectors from 'features/user/services/selectors';

type Props = {
  selectedStaffIds?: string[];
  onSelectStaff?: (staff: IStaffAvailableItem) => void;
};

const ChooseStaffSyncWaitingV2Form = ({ selectedStaffIds, onSelectStaff }: Props) => {
  const [search, setSearch] = useState('');
  const allSetting = shopSelectors.data.allSetting();

  const _staffListStore = userSelectors.listAvailableWorking();
  const staffListPureStore = useMemo(() => {
    const data = _staffListStore.filter(o=>o.activeTurn);
    if (!allSetting?.hideStaffBusy) return data;
    return data.filter(staff => !staff.isBusy);
  }, [_staffListStore, allSetting]);

  const _staffList = useMemo(() => {
    const searchText = search?.toLocaleLowerCase();
    if (!searchText) return staffListPureStore;
    return staffListPureStore.filter((staff) => {
      if (staff.staffName?.toLocaleLowerCase()?.includes(searchText)) return true;
      return false;
    });
  }, [search, staffListPureStore]);

  return (
    <Container>
      <div>
        <InputSearchSuffixIcon
          placeholder='Search by Staff’s Name'
          onChange={(val) => setSearch(val)}
        />
      </div>
      <StaffList>
        {_staffList.map((staff) => {
          const isSelected = selectedStaffIds?.includes(staff.staffId);
          return (
            <StaffItem
              key={staff.staffId}
              onClick={() => onSelectStaff?.(staff)}
              className={`${isSelected ? 'active' : ''}`}
            >
              {isSelected && (
                <SelectedBox>
                  <IconClose />
                </SelectedBox>
              )}
              <Avatar src={staff?.staffAvatar} size={80} icon={<UserOutlined />} />
              <div className='staff_name'>{staff.staffName}</div>
            </StaffItem>
          );
        })}
      </StaffList>
    </Container>
  );
};

export default ChooseStaffSyncWaitingV2Form;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const StaffList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 8px;
`;

const StaffItem = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 5px;
  background: #fff;
  transition: all 0.3s ease;
  &.active {
    background: #c6e9ef;
  }
  .staff_name {
    color: #1d2129;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

const SelectedBox = styled.div`
  z-index: 1;
  position: absolute;
  top: 4px;
  right: 4px;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 3px;
  background: #2d6772;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IconClose = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>
    <path
      d='M11.2741 20.6668C10.9184 20.6668 10.5805 20.518 10.3314 20.2576L5.29775 14.9931C4.78194 14.4536 4.78194 13.5607 5.29775 13.0212C5.81356 12.4817 6.66731 12.4817 7.18313 13.0212L11.2741 17.2998L20.4164 7.7381C20.9322 7.19863 21.786 7.19863 22.3018 7.7381C22.8176 8.27757 22.8176 9.17049 22.3018 9.70996L12.2168 20.2576C11.9678 20.518 11.6299 20.6668 11.2741 20.6668Z'
      fill='white'
    />
  </svg>
);
